const widgetData = [
    {
        icon: 'fe-shopping-bag',
        value: 12145,
        title: 'Today\'s Sales',
        color: 'blue',
        progressValue: 60
    },
    {
        icon: 'fe-shopping-cart',
        value: 1576,
        title: 'Total cards',
        color: 'success',
        progressValue: 49
    },
    {
        icon: 'fe-clock',
        value: 8947,
        title: 'Pending',
        color: 'warning',
        progressValue: 18
    },
    {
        icon: 'fe-gift',
        value: 178,
        title: '99Gift Orders',
        color: 'info',
        progressValue: 74
    }
];

const lifetimeSalesAreaChart = {
    series: [{
        name: 'Desktop',
        data: [0, 23, 43, 35, 44, 45, 56, 37, 40],
    }, {
        name: 'Laptop',
        data: [25, 23, 26, 24, 25, 32, 30, 24, 19]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        colors: ['#00acc1', '#f1556c'],
        stroke: {
            curve: 'straight',
            width: 1,
        },
        dataLabels: {
            enabled: false
        },
        sparkline: {
            enabled: true
        },
        grid: {
            show: false,
            padding: {
                top: 40,
                left: 0,
                right: 0,
                bottom: 0
            }
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                show: false
            },
            y: {
                title: {
                    text: undefined,
                }
            },
            marker: {
                show: false
            }
        },
        xaxis: {
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            lines: {
                show: false,
            }
        }
    }
};

const incomeAmountsLineChart = {
    series: [{
        name: 'Revenue',
        data: [70, 90, 100, 140, 50, 80, 130, 90, 80, 120, 130, 140, 90, 100, 75],
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ['#00acc1'],
        dataLabels: {
            enabled: false
        },
        sparkline: {
            enabled: true,
        },
        grid: {
            show: false,
            padding: {
                top: 40,
                left: 0,
                right: 0,
                bottom: 0
            }
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                show: false
            }
        },
        stroke: {
            show: true,
            width: 1,   // thickness of the lines
        },
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },
        xaxis: {
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            lines: {
                show: false,
            }
        }
    }
};

const productPieChart = {
    series: [],
    chartOptions: {
        labels: [],
        pie: {
            expandOnClick: true
        },
        colors: ['#00acc1', '#4b88e4', '#fd7e14'],
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                show: false
            }
        },
        grid: {
            show: false,
            padding: {
                top: 30,
                left: 0,
                right: 0,
                bottom: 0
            }
        },
    },
};

const productData = [

];


export { widgetData, lifetimeSalesAreaChart, incomeAmountsLineChart, productPieChart, productData };

